import React, { useState, useCallback, useEffect } from 'react'
import { Container, Top } from '../styles'
import { DefaultAdminPage } from '../../DefaultPages'
import history from '../../../store/history'
import ecbrApi from '../../../services/ecbrApi'

import {
  Button,
  Search,
  BoxContainer,
  Table,
  InsideFooter,
  Breadcrumbs,
  Typography
} from '../../../components'
import StatusBadge from '../../../components/StatusBadge'
import HeaderItem from '../../../components/Table/HeaderItem'
import RowItem from '../../../components/Table/RowItem'
import { PaginationOrder } from '../../../constants/pagination'
import { useInfinitePagination } from '../../../hooks/useInfinitePagination'
import { CompanyStatus, CompanyStatusColors } from '../../../constants/company'
import ErrorMessage from '../../../components/Form/ErrorMessage'

const pagination = { page: 1, take: 5 }

const Companies = () => {
  const [error, setError] = useState('')
  const [searchParameters, setSearchParameters] = useState({
    ...pagination,
    order: PaginationOrder.ASC,
    name: '',
    cnpj: '',
    urlWebsite: ''
  })

  const {
    data: companies,
    fetchNextPage,
    hasNextPage,
    isLastPage,
    isFetching,
    isLoading,
    refetch
  } = useInfinitePagination(
    'companies',
    async (params) => {
      const { pageParam = searchParameters.page } = params
      return ecbrApi.companies.getAll({
        ...searchParameters,
        page: pageParam || searchParameters.page
      })
    },
    {
      onSuccess: () => {
        setError('')
      },
      onError: () => {
        setError('Não foi possível carregar os dados')
      }
    }
  )

  useEffect(() => {
    refetch()
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [searchParameters])

  const handleSearch = useCallback(
    (value) => {
      setSearchParameters({
        ...searchParameters,
        name: value,
        page: pagination.page
      })
    },
    [searchParameters]
  )

  const handleGoToBrands = useCallback((company) => {
    history.push(`/admin/companies/${company.id}/brands`)
  }, [])

  return (
    <DefaultAdminPage page="empresas">
      <Container>
        <Top>
          <Breadcrumbs />
          {/* <Button
            type="button"
            variant="outlined"
            text="Exportar excel"
            width="120px"
          /> */}
        </Top>
        <h3>Aqui você pode gerenciar todas empresas cadastradas no sistema</h3>
        <Search
          placeholder="pesquisar empresa"
          onSearch={handleSearch}
          search={searchParameters.name}
          setSearch={(value) =>
            setSearchParameters({ ...searchParameters, name: value })
          }
        />
        <BoxContainer>
          {!error && (
            <Table templateColumns="12% 12% 14% 20% 10% 4% 10% 14%">
              <header>
                <ul>
                  <HeaderItem>Razão Social</HeaderItem>
                  <HeaderItem>CNPJ</HeaderItem>
                  <HeaderItem>Website</HeaderItem>
                  <HeaderItem>Endereço</HeaderItem>
                  <HeaderItem>Cidade</HeaderItem>
                  <HeaderItem>UF</HeaderItem>
                  <HeaderItem>Status</HeaderItem>
                  <HeaderItem>Ações</HeaderItem>
                </ul>
              </header>
              <main>
                {companies?.map?.((company) => (
                  <ul key={company.cnpj}>
                    <RowItem>{company.corporateName}</RowItem>
                    <RowItem>{company.cnpj}</RowItem>
                    <RowItem>{company.urlWebsite}</RowItem>
                    <RowItem>{company.address}</RowItem>
                    <RowItem>{company.city}</RowItem>
                    <RowItem>{company.state}</RowItem>
                    <RowItem>
                      <StatusBadge
                        text={CompanyStatus[company.status]}
                        color={CompanyStatusColors[company.status]}
                      />
                    </RowItem>
                    <RowItem>
                      <Button
                        type="button"
                        variant="outlinedLinkDefault"
                        text="Visualizar Lojas"
                        onClick={() => handleGoToBrands(company)}
                        fontSize={14}
                      />
                    </RowItem>
                  </ul>
                ))}
              </main>
              <footer>
                {hasNextPage && !isLastPage && (
                  <Button
                    type="button"
                    variant="outlined"
                    text={
                      isLoading || isFetching ? 'Carregando...' : 'Ver mais'
                    }
                    width="120px"
                    onClick={() => fetchNextPage()}
                  />
                )}
              </footer>
            </Table>
          )}
          {error && <ErrorMessage>{error}</ErrorMessage>}
          {!error && !isLoading && !isFetching && !companies?.length && (
            <Typography type="text" spacing="0 1rem">
              Nenhuma empresa cadastrada
            </Typography>
          )}
        </BoxContainer>
        <InsideFooter />
      </Container>
    </DefaultAdminPage>
  )
}

export default Companies
